module.exports = ['$scope', function($scope) {

    $scope.redirectHome = function(){
        location.replace("/member/home/");
    }
}];